import React, { FC, useCallback, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import Label from '../label/label';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { requiredValidation } from '../../utilities/Validation';
import { IAppState } from '../../store/types';
import { useSelector } from 'react-redux';
import { Filter } from '../../models/Filter';
import { appendFilter } from '../../utilities/filters';
import Description from '../description/Description';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';
import { getAllTemplateReportTypeNamesWithPagination } from '../../services/reportService';

export const ReportCard: FC = () => {
    const { translate } = useLocale();
    const { values, errors, setFieldValue } = useFormikContext<any>();
    const siteId = useSelector((state: IAppState) => state.site.site.value);
    const [filters, setFilters] = useState<Filter[]>([])
    const siteName = useSelector((state: IAppState) => state.site.site.label)
    const user = useSelector((state: IAppState) => (state.userInfo));

    useEffect(() => {
        setFilters(appendFilter(siteId, "Site", "site.id", []));
    }, [siteId])

    const onSelect = (id, item) => {
        setFieldValue('typeId', item.reportType)
        setFieldValue('reportSubTypeId', item.reportSubType)
        setFieldValue('reportId', id)
    }

    return <>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='nameLabelId'>
                    <Label
                        htmlFor="name"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>
                <Field id='nameInputFieldId'
                    type="text"
                    name="name"
                    autoFocus
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => requiredValidation(value, translate)} />
            </div>
        </div>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="site"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.site)}:</Label>
                </div>
                {values.id
                    ? <Field
                        value={values.siteName}
                        disabled={true}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                    : <Field
                        value={siteName}
                        disabled={true}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />}
            </div>
        </div>
        <div className="flex flex-row mb-6 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='reportTypeLabelId'>
                    <Label htmlFor='reportId'
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.type)}:</Label>
                    {errors.reportId ? <span className='text-red-600 text-xs'>{errors.reportId}</span> : null}
                </div>

                <span id='reportTypeId'>
                    {values.id
                        ? <Field
                            value={values.type}
                            disabled={true}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                        : 
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.type)}
                            key={"reportIdKey"}
                            accessor='reportId'
                            dataMethod={(listQuery) => getAllTemplateReportTypeNamesWithPagination(
                                {...listQuery, 
                                    filters: appendFilter('TEMPLATE', "Default Reports", "rptSysname", [], "=in=")
                                }, 
                                user.profileId
                            )}
                            searchAccessor={'trnName'}
                            onSelect={(id, item) => onSelect(id, item)}
                            required={true}
                        />
                        }
                </span>
            </div>
        </div>
        <div className="flex flex-row flex-1 pt-3 ">
            <div className="flex flex-col flex-1 pr-3">
                <Description title={translate.byKey(TranslationKeys.notes)} modalDescription={true} />
            </div>
        </div>
    </>
};


